export function Offices(props: React.ComponentPropsWithoutRef<"ul">) {
  return (
    <ul {...props}>
      <li>
        <address className="text-sm not-italic text-ink-300">
          <strong className="text-ink-50">Metro Detroit</strong>
          <br />
          41140 Garfield Road #202
          <br />
          Clinton Township, MI 48038
        </address>
      </li>
    </ul>
  );
}
